module.exports = "images/apple-icon-120x120.3662d4f37263397865500ce4540a8e22.png";